import {message} from 'antd';
import copy from "copy-to-clipboard";
import storage from "./storage";
import Api from "../api";

// 获取地址栏搜索key-value
export function getSearchParams() {
    let searchStr = location.search.replace('?', '')
    let searchObject = {
        pathname: location.pathname,
    }
    if (searchStr) {
        let searchArr = searchStr.split('&')
        searchArr.forEach(item => {
            let arr = item.split("=")
            searchObject[arr[0]] = decodeURIComponent(arr[1])
        })
    }
    return searchObject
}

// 弹窗提示
export function tipFunc (content, type='success', duration=0.5) {
    message.config({
        top: 300
    })
    if (message[type]) {
        message[type]({
            content: content,
            duration: duration,
            className: 'tipBox',
        })
    }
}

// 二进制转换为图片url路径
function binaryToUrl (binary, opt={}) {
    let blob = new Blob([binary], opt);
    return (window.URL || window.webkitURL).createObjectURL(blob);
}

// 处理响应
export function responseDataFilter (res, text) {
    const {code, dataList, msg} = res || {};
    if (code > 0) {
        return dataList;
    } else {
        message.error(msg || res?.message || text || "请求失败！");
    }
}

// 判断值是否有效
export function valueIsValid (val) {
    let value = val;
    const isInvalid = value === undefined || value === null || value === "";
    if (isInvalid) {
        value = "";
    }
    return {value, isValid: !isInvalid};
}



// 防抖函数
export function debounce(func, delay) {
    let timer;
    return function () {
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(() => {
            clearTimeout(timer)
            func()
        }, delay)
    }
}

// 判断是不是 视频
export function isVideoFunc(val) {
    let videoType = [
        "avi", "mp4", "mov", "qt", "mkv",
        "wmv", "xvid", "tc", "flv", "imax",
        "psd", "hr-hdtv",
    ];
    let isVideo = false;
    if (val) {
        if (val.includes("base64")) {
            isVideo = val.includes("video");
        } else {
            let arr = val.split(".");
            let lastStr = arr[arr.length - 1];
            isVideo = videoType.includes(lastStr);
        }
    }

    return isVideo;
}

// 复制字符串
export function copyToClip(str) {
    copy(str || "", {
        message: "复制失败，请升级浏览器！",
        format: "text/plain",
        debug: true,
        onCopy: () => {
            message.success("复制成功！")
        }
    });
}

// 补充模块
export function repairModuleFunc(list, width, divisor) {
    let dataList = [...list];
    const oneRowNumber = Math.floor(width / divisor);
    const len = dataList?.length || 0;
    const isMoreRow = len > oneRowNumber;
    if (isMoreRow && oneRowNumber > 1) {
        const remainder = len % oneRowNumber;
        if (remainder > 0) {
            for (let i = 0; i < (oneRowNumber - remainder); i++) {
                dataList.push({repair: true, id: Math.random()});
            }
        }
    }
    return {dataList, isMoreRow, len};
}
